// @ts-nocheck
import styled from "styled-components";
import Modal from "react-modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faHeart, faFlag, faStar } from "@fortawesome/free-solid-svg-icons";
import { faHeart as farHeart, faFlag as farFlag, faStar as farStar } from '@fortawesome/free-regular-svg-icons';

import useStore from "hooks/useStore";

const customStyles: any = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    padding: 0,
    backgroundColor: "rgba(20, 20, 20, 0.7)",
  },
  content: {
    position: "absolute",
    borderRadius: "12px",
    background: "rgb(255, 255, 255)",
    overflow: "none",
    outline: "none",
    left: 0,
    right: 0,
    margin: "0px auto",
    padding: 0,
    width: "600px",
    height: "25vh",
    top: "100px",
    display: 'flex',
    flexDirection: 'column'
  },
};
Modal.setAppElement("#main");

const FavoritesModal = ({showModal, hideModal, id}: any) => {
  const { toggleFavorites, isFavorited, isFutured, isVisited } = useStore();

  const addFavorite = () => {
    if (isFavorited) {
      toggleFavorites(id, 'removeFavorites', 'isFavorited');
    } else {
      toggleFavorites(id, 'addFavorites', 'isFavorited');
    }
  };

  const addVisited = () => {
    if (isVisited) {
      toggleFavorites(id, 'removeVisited', 'isVisited');
    } else {
      toggleFavorites(id, 'addVisited', 'isVisited');
    }
  };

  const addFutured = () => {
    if (isFutured) {
      toggleFavorites(id, 'removeFuture', 'isFutured');
    } else {
      toggleFavorites(id, 'addFuture', 'isFutured');
    }
  };

  return (
    <Modal
      isOpen={showModal}
      onRequestClose={hideModal}
      style={customStyles}
      className="kampp-modal"
      contentLabel="Filter Modal"
      closeTimeoutMS={250}
    >
      <HeaderContainer>
        <CloseIcon onClick={hideModal} icon={faTimes} />
        <HeaderTitle> Listeme Kaydet</HeaderTitle>
        <Gap />
      </HeaderContainer>
      <ContentContainer>
        <ItemContainer onClick={addFavorite}>
          <Icon icon={isFavorited ? faHeart : farHeart} style={{color: '#e78136'}} /> 
          Favoriler
        </ItemContainer>
        <ItemContainer onClick={addFutured}>
          <Icon icon={isFutured ? faFlag : farFlag} style={{color: 'rgb(80,139,71)'}} /> 
          Gidilecekler
        </ItemContainer>
        <ItemContainer onClick={addVisited}>
          <Icon icon={isVisited ? faStar : farStar} style={{color: 'rgb(243,193,79)'}} /> 
          Gittiklerim
        </ItemContainer>
      </ContentContainer>

    
    </Modal>
  )
}

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 10px;
  border-bottom: 1px solid rgb(235, 235, 235) !important;
  padding: "0px 20px";
`;

const ContentContainer = styled.div`
  padding: 24px 24px 28px 12px;
`;

const HeaderTitle = styled.span`
  color: rgb(34, 34, 34);
  font-size: 16px;
  line-height: 20px;
  font-weight: 800;
`;

const CloseIcon = styled(FontAwesomeIcon)`
  width: 30px;
  height: 30px;
  cursor: pointer;
  padding: 5px 5px;
`;

const Icon = styled(FontAwesomeIcon)`
  width: 30px;
  height: 30px;
  cursor: pointer;
  padding: 5px 5px;
  margin-right: 10px;
`;

const ItemContainer = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgb(235, 235, 235) !important;
  padding: 10px 0px;
  cursor: pointer;
`

const Gap = styled.div``;

export default FavoritesModal;